import React, { useState } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useConfigStore } from '../store/configStore';
import axiosInstance from '../lib/axios';
import { toast } from 'sonner';
import { Button } from './ui/button';
import { Sparkles, Loader2 } from 'lucide-react';



// Etiqueta en lenguaje llano (pedido del dueño): "prompt" no es término que
// todos los usuarios conozcan; cada campo puede pasar su propia etiqueta
// (p. ej. "Mejorar descripción" en Generar Imagen).
const PromptImprover = ({ currentPrompt, onImproved, disabled = false, label = 'Mejorar con IA' }) => {
  const { token, user } = useAuthStore();
  const { apiKey, model } = useConfigStore();
  const [improving, setImproving] = useState(false);

  const handleImprove = async () => {
    // No client-side API-key gate: the backend falls back to a platform key
    // when the user has no BYOK key configured.

    if (user?.role !== 'admin') {
      toast.error('Solo administradores pueden usar esta función');
      return;
    }

    if (!currentPrompt || !currentPrompt.trim()) {
      toast.error('Escribe un texto primero');
      return;
    }

    setImproving(true);
    try {
      const response = await axiosInstance.post(
        '/ai/improve-prompt',
        { prompt: currentPrompt, api_key: apiKey, model }
      );

      const improved = response.data.improved_prompt;
      onImproved(improved);
      toast.success('Texto mejorado con IA');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al mejorar prompt');
    } finally {
      setImproving(false);
    }
  };

  // Only show to admins
  if (user?.role !== 'admin') {
    return null;
  }

  return (
    <Button
      data-testid="improve-prompt-button"
      variant="outline"
      size="sm"
      onClick={handleImprove}
      disabled={disabled || improving || !currentPrompt}
      className="glass border-purple-200 hover:bg-purple-50 dark:border-purple-800 dark:hover:bg-purple-900/40"
    >
      {improving ? (
        <>
          <Loader2 className="w-4 h-4 mr-2 animate-spin" />
          Mejorando...
        </>
      ) : (
        <>
          <Sparkles className="w-4 h-4 mr-2 text-purple-600" />
          {label}
        </>
      )}
    </Button>
  );
};

export default PromptImprover;
